import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { bootError, bootMarkMounted, bootSetStage } from "@/lib/boot-debug";

bootSetStage('Iniciando React...', 'Bundle carregado, montando aplicação');

// Service Worker REMOVIDO temporariamente.
// Estava causando problemas de cache no mobile (Android) e possivelmente
// servindo bundles antigos com configurações de chunks incompatíveis.
// Limpa qualquer SW antigo registrado em deploys anteriores.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister().catch(() => null));
  }).catch(() => null);
  if ('caches' in window) {
    caches.keys().then((keys) => {
      keys.forEach((k) => caches.delete(k).catch(() => null));
    }).catch(() => null);
  }
}

function hideSplash() {
  const loader = document.getElementById('initial-loader');
  if (loader) {
    loader.classList.add('hide');
    setTimeout(() => loader.remove(), 350);
  }
}

function showFatalError(message: string) {
  hideSplash();
  const root = document.getElementById('root');
  if (!root) return;
  root.innerHTML = `
    <div style="position:fixed;inset:0;background:#070B1A;color:#fff;display:flex;align-items:center;justify-content:center;padding:24px;font-family:system-ui,-apple-system,Segoe UI,Roboto,sans-serif;">
      <div style="max-width:420px;text-align:center;">
        <img src="/construzilla-logo.png?v=6" alt="Construzilla" style="max-width:96px;margin:0 auto 12px;display:block;" />
        <h2 style="font-size:20px;font-weight:800;margin-bottom:8px;">Constru<span style="color:#F59E0B">zilla</span></h2>
        <p style="font-size:14px;opacity:.85;margin-bottom:16px;">Não foi possível iniciar o aplicativo. Toque em recarregar.</p>
        <details style="font-size:11px;opacity:.6;margin-bottom:16px;text-align:left;"><summary style="cursor:pointer;">Detalhes</summary><pre style="white-space:pre-wrap;margin-top:8px;">${message.replace(/[<>&]/g, (c) => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]!))}</pre></details>
        <button onclick="(async()=>{try{if('caches'in window){const k=await caches.keys();await Promise.all(k.map(x=>caches.delete(x)))}}catch(e){};location.reload()})()" style="background:#F59E0B;color:#070B1A;border:none;border-radius:8px;padding:10px 20px;font-weight:700;font-size:14px;cursor:pointer;">Recarregar aplicativo</button>
      </div>
    </div>`;
}

// Timeout de segurança: se o React não montar em 15s, mostra erro
const splashTimeout = window.setTimeout(() => {
  if (document.getElementById('initial-loader')) {
    console.error('[main] Timeout: React não montou em 15s');
    showFatalError('Tempo limite excedido ao carregar a aplicação.');
  }
}, 15000);

window.addEventListener('error', (e) => {
  const msg = e?.message || '';
  if (/loading.*chunk|dynamically imported|failed to fetch/i.test(msg)) {
    console.error('[main] Chunk error:', msg);
  }
});
window.addEventListener('unhandledrejection', (e) => {
  const msg = String(e?.reason?.message || e?.reason || '');
  if (/loading.*chunk|dynamically imported|failed to fetch/i.test(msg)) {
    console.error('[main] Chunk rejection:', msg);
  }
});

try {
  const rootEl = document.getElementById('root');
  if (!rootEl) throw new Error('Elemento #root não encontrado');
  createRoot(rootEl).render(<App />);

  requestAnimationFrame(() => {
    window.clearTimeout(splashTimeout);
    bootMarkMounted();
    hideSplash();
  });
} catch (err) {
  window.clearTimeout(splashTimeout);
  bootError('Falha ao montar React', err instanceof Error ? err.message : String(err));
  console.error('[main] Falha ao montar React:', err);
  showFatalError(err instanceof Error ? err.message : String(err));
}
